/* eslint-disable import/no-extraneous-dependencies */
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getClientes = async (
  cancel: any,
  query: string,
  classificacao: string[],
  page: number,
  segmento: string[]
): Promise<GetProductsType | { message: string }> => {
  try {
    const result = await apiService.get('app/cliente', {
      cancelToken: cancel.token,
      params: {
        query,
        classificacao,
        segmento,
        page: page - 1,
        size: 7,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getCLientResume = async (
  id: string
): Promise<GetProductResumeType | { message: string }> => {
  try {
    const result = await apiService.get(`app/cliente/${id}/resumo`, {
      params: {
        id,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getProductsDetails = async (
  id: string,
  classificacao: Classification
): Promise<GetDetailsType[] | { message: string }> => {
  try {
    const result = await apiService.get(`app/cliente/${id}/produtos`, {
      params: {
        classificacao,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getClientsAll = async (
  query: string
): Promise<GetClientsAll | { message: string }> => {
  try {
    const result = await apiService.get('app/cliente/all', {
      params: {
        query,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Opcoes do filtro de Segmento (GET app/cliente/segmentos). Ja vem do backend sem repetidos,
// ordenado e restrito ao escopo do usuario logado - o vendedor so ve os segmentos da carteira dele.
export const getSegmentos = async (): Promise<
  string[] | { message: string }
> => {
  try {
    const result = await apiService.get('app/cliente/segmentos')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
